import { Customer } from '../@types';
import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetCustomerRequest = {
	customerId?: number;
	shardName?: string;
};

export type GetCustomerResponse = Customer;

export const getCustomer = createGetEndpoint<GetCustomerRequest, GetCustomerResponse>(
	(request) => `/api/v3/core/customers/${request?.customerId ?? 'current'}`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		}
	}
);
